


































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import Movie from '@/objects/movie';
import Rating from '../Rating.vue';
import MovieListItemButtons from './MovieListItemButtons.vue';
import MovieRate from '@/enums/movieRate';
import ServiceAgent from '@/services/serviceAgent';
import MovieType from '@/enums/movieType';

const serviceAgent = new ServiceAgent();

@Component({
    components: {
        Rating,
        MovieListItemButtons,
    },
})
export default class MovieListItem extends Vue {
    @Prop() movie!: Movie;

    MovieType = MovieType;

    imageUrl = 'https://moviediarystorage.blob.core.windows.net/movies';

    isItemExpanded = false;

    get imageSrc() {
        let src = '';

        if (this.movie) {
            src = this.imageUrl + this.movie.PosterPath;
        }

        return src;
    }

    async itemClickHandler(event: any) {
        this.isItemExpanded = !this.isItemExpanded;
        let timeout = 0;
        const area = document.getElementsByClassName('my-movies-list')[0] as HTMLElement;
        const clickedItem = event.currentTarget as HTMLElement;
        let targetElement!: HTMLElement;

        if (clickedItem.parentElement?.classList.contains('movie-list-item')) {
            targetElement = clickedItem.parentElement;
        } else if (clickedItem.parentElement?.parentElement?.classList.contains('movie-list-item')) {
            targetElement = clickedItem.parentElement.parentElement;
        }

        if (!targetElement) return;

        const itemsCount = targetElement.parentElement?.children.length;

        if (itemsCount && targetElement.clientHeight * itemsCount < area.clientHeight) {
            timeout = 200;
        }

        const options = {
            duration: 500,
            offset: 0,
            container: area,
        };

        setTimeout(() => {
            this.$vuetify.goTo(targetElement, options);
        }, timeout);
    }
}
